<template>
    <!-- <v-dialog v-model="show" persistent fullscreen> -->

        <div id="video-chat-dialog" :class="{minimize: $store.state.minimizeWebRtc}">

            <v-btn id="minimize-web-rtc" icon outlined @click="minimizeWebRtc" v-if="acceptedInvite">
                <v-icon large>mdi-fullscreen-exit</v-icon>
            </v-btn>

            <div id="contact-microphone-status-container" :class="{show: showContactMicrophoneStatus}">
                <div id="contact-microphone-status" v-if="acceptedInvite">
                    <span class="on" v-if="contactMicrophoneOn"><v-icon color="#00ff00">mdi-microphone</v-icon> {{`${targetUser.user_username}'s microphone is on`}}</span>
                    <span class="off" v-if="!contactMicrophoneOn"><v-icon color="#ff0000">mdi-microphone-off</v-icon> {{`${targetUser.user_username}'s microphone is off`}}</span>
                </div>
            </div>

            <video id="received_video" autoplay :class="{hide: !contactCameraOn}" v-if="acceptedInvite"></video> <!-- dont mute for prod -->
            <div id="contact-camera-off-container" v-if="acceptedInvite && !contactCameraOn">
                <img class="user-image" :src="targetUser.userImage" v-if="targetUser.userImage" />
                <div class="stock-image" v-if="!targetUser.userImage">
                    <span class="letter">{{targetUser.user_username[0].toUpperCase()}}</span>
                </div>
            </div>

            <video id="local_video" autoplay muted v-if="acceptedInvite"></video>






            <div class="outgoing-call-container" v-if="targetUser && $store.state.webRtc.outgoing && !acceptedInvite">
                <span v-text="`Calling ${targetUser.user_fullname}`" />
                <img :src="targetUser.userImage" v-if="targetUser.userImage" />
                <div class="stock-image" v-if="!targetUser.userImage">
                    <span class="letter">{{targetUser.user_username[0].toUpperCase()}}</span>
                </div>
                <div class="dots">
                    <div class="dot one mr-1" />
                    <div class="dot two mr-1" />
                    <div class="dot three mr-1" />
                    <div class="dot four mr-1" />
                    <div class="dot five" />
                </div>
                <!-- <audio src="@/assets/hangouts_outgoing.mp3" type="audio/mpeg" autoplay></audio> -->
                <audio src="audio/hangouts_outgoing.mp3" type="audio/mpeg" autoplay loop></audio>
            </div>

            <div class="incoming-call-container" v-if="targetUser && $store.state.webRtc.incoming && !acceptedInvite">
                <span v-text="`Incoming Call From ${targetUser.user_fullname}`"></span>
                <img :src="targetUser.userImage" v-if="targetUser.userImage" />
                <div class="stock-image" v-if="!targetUser.userImage">
                    <span class="letter">{{targetUser.user_username[0].toUpperCase()}}</span>
                </div>
                <div class="button-container">
                    <v-btn class="mr-6 control-button" fab color="green" x-large @click="acceptWebrtcInvite">
                        <v-icon>mdi-phone</v-icon>
                    </v-btn>
                    <v-btn class="ml-6 control-button" fab color="red" x-large @click="rejectWebrtcInvite">
                        <v-icon>mdi-phone-off</v-icon>
                    </v-btn>
                </div>
                <audio src="audio/hangouts_outgoing.mp3" type="audio/mpeg" autoplay loop></audio>
            </div>







            <div id="in-call-buttons-container" :class="{show: showControls}" v-if="acceptedInvite">
                <div id="toggle-microphone" class="control-button" :class="{inactive: !microphoneOn}" @click="toggleMicrophone" v-if="$store.state.webRtc.outgoing || acceptedInvite">
                    <v-icon v-if="microphoneOn">mdi-microphone</v-icon>
                    <v-icon v-if="!microphoneOn">mdi-microphone-off</v-icon>
                </div>

                <div id="end-call-button" class="control-button" @click="closeVideoCallClick" v-if="$store.state.webRtc.outgoing || acceptedInvite">
                    <v-icon>mdi-phone</v-icon>
                </div>

                <div id="toggle-camera" class="control-button" :class="{inactive: !cameraOn}" @click="toggleCamera" v-if="$store.state.webRtc.outgoing || acceptedInvite">
                    <v-icon v-if="cameraOn">mdi-video</v-icon>
                    <v-icon v-if="!cameraOn">mdi-video-off</v-icon>
                </div>

                <div id="share-screen-button" class="control-button" @click="shareScreenClick" v-if="$store.state.webRtc.outgoing || acceptedInvite">
                    <v-icon>mdi-monitor-multiple</v-icon>
                </div>
            </div>

            

            

        </div>

    <!-- </v-dialog> -->
</template>

<script>
import Vue from "vue";
export default {
    name: 'WebRtc',
    props: {
        value: Boolean,
    },
    components: {
    },
    data: () => ({
        targetUser: null,
        myPeerConnection: null,
        rtcTransceiver: null,
        webcamStream: null,
        imTheCaller: false,

        mediaConstraints: {
            audio: true,
            video: true
            // video: {
            //     aspectRatio: {
            //         ideal: 1.333333     // 3:2 aspect is preferred
            //     }
            // }
        },


        microphoneOn: true,
        contactMicrophoneOn: true,
        showContactMicrophoneStatus: false,

        cameraOn: true,
        contactCameraOn: true,

        showControls: false,
        showControlsIntervalFunc: null,
        showControlsTimerSeconds: 2,
        showControlsTimeoutSeconds: 2,

        acceptedInvite: false
    }),

    computed: {
        show: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value);
            }
        },

    },

    methods: {
        acceptWebrtcInvite: function() {
            this.$socket.emit('webrtc_invite_reply', {response: 'accept', to_sid: this.targetUser.sid});
            this.acceptedInvite = true;
        },
        rejectWebrtcInvite: function() {
            this.$socket.emit('webrtc_invite_reply', {response: 'reject', to_sid: this.targetUser.sid});
            // Close it down
            let webRtc = {
                show: false, 
                contact: null,
                outgoing: false,
                incoming: false,
            };
            this.$store.commit('setWebRtc', webRtc);
        },

        prepareVideoChatInvite: async function() {
            this.imTheCaller = true;
            console.log('preparing video invite');
            console.log('Contact Obj', this.targetUser);

            // TODO: check that that cant call themselves.


            this.createPeerConnection();

            // Get the webcam stream and set the local video
            try {
                this.webcamStream = await navigator.mediaDevices.getUserMedia(this.mediaConstraints);
                document.getElementById("local_video").srcObject = this.webcamStream;
            } catch(error) {
                this.handleGetUserMediaError(error);
                return;
            }

            // Send the webcam stream to the RTCPeerConnection
            try {
                let webcamStreamMediaTracks = this.webcamStream.getTracks();
                let self = this;
                console.log('adding tracks. myPeerConnection: ', this.myPeerConnection);
                webcamStreamMediaTracks.forEach(
                    self.rtcTransceiver = track => self.myPeerConnection.addTransceiver(track, {streams: [self.webcamStream]})
                );
                // webcamStreamMediaTracks.forEach(track => {
                //     self.rtcTransceiver = track;
                //     self.myPeerConnection.addTransceiver(track, {streams: [self.webcamStream]});
                // });
            } catch(err) {
                this.handleGetUserMediaError(err);
            }

            console.log('media tracks', this.webcamStream.getTracks());
        },



        createPeerConnection: async function() {
            console.log('Creating the RTCPeerConnection');
            this.myPeerConnection = new RTCPeerConnection({
                iceServers: [
                    {
                        //urls: "turn:" + myHostname,  // A TURN server
                        // urls: "turn:" + TELSA.apiHost,
                        // username: "webrtc",
                        // credential: "turnserver"

                        //url:'stun:12.345.678.910:3478'
                        urls:'stun:12.345.678.910:3478'
                    }
                ]
            });

            console.log('Creating the RTCPeerConnection handlers');
            // Set up event handlers for the ICE negotiation process.
            this.myPeerConnection.onicecandidate = this.handleICECandidateEvent;
            this.myPeerConnection.oniceconnectionstatechange = this.handleICEConnectionStateChangeEvent;
            this.myPeerConnection.onicegatheringstatechange = this.handleICEGatheringStateChangeEvent;
            this.myPeerConnection.onsignalingstatechange = this.handleSignalingStateChangeEvent;
            this.myPeerConnection.onnegotiationneeded = this.handleNegotiationNeededEvent;
            this.myPeerConnection.ontrack = this.handleTrackEvent;
        },














        // Handles |icecandidate| events by forwarding the specified
        // ICE candidate (created by our local ICE agent) to the other
        // peer through the signaling server.
        handleICECandidateEvent: function(event) {
            if (event.candidate) {
                console.log("*** Outgoing ICE candidate: " + event.candidate.candidate);
                console.log("*** Outgoing ICE candidate TARGET USER: ", this.targetUser);
                let webRtcObj = {
                    type: "new_ice_candidate",
                    to_sid: this.targetUser.sid,
                    candidate: event.candidate
                }
                this.socketSend(webRtcObj);
            }

        },

        // Handle |iceconnectionstatechange| events. This will detect
        // when the ICE connection is closed, failed, or disconnected.
        //
        // This is called when the state of the ICE agent changes.
        handleICEConnectionStateChangeEvent: function(event) {
            console.log("*** ICE connection state changed to " + this.myPeerConnection.iceConnectionState);
            switch(this.myPeerConnection.iceConnectionState) {
                case "closed":
                case "failed":
                case "disconnected":
                    this.closeVideoCall();
                    break;
            }
        },

        // Handle the |icegatheringstatechange| event. This lets us know what the
        // ICE engine is currently working on: "new" means no networking has happened
        // yet, "gathering" means the ICE engine is currently gathering candidates,
        // and "complete" means gathering is complete. Note that the engine can
        // alternate between "gathering" and "complete" repeatedly as needs and
        // circumstances change.
        //
        // We don't need to do anything when this happens, but we log it to the
        // console so you can see what's going on when playing with the sample.
        handleICEGatheringStateChangeEvent: function(event) {
            console.log("*** ICE gathering state changed to: " + this.myPeerConnection.iceGatheringState);
        },

        // Set up a |signalingstatechange| event handler. This will detect when
        // the signaling connection is closed.
        //
        // NOTE: This will actually move to the new RTCPeerConnectionState enum
        // returned in the property RTCPeerConnection.connectionState when
        // browsers catch up with the latest version of the specification!
        handleSignalingStateChangeEvent: function(event) {
            console.log("*** WebRTC signaling state changed to: " + this.myPeerConnection.signalingState);
            switch(this.myPeerConnection.signalingState) {
                case "closed":
                    this.closeVideoCall();
                    break;
            }
        },

        // Called by the WebRTC layer to let us know when it's time to
        // begin, resume, or restart ICE negotiation.
        handleNegotiationNeededEvent: async function() {
            console.log("*** Negotiation needed");
            try {
                console.log("---> Creating offer");
                const offer = await this.myPeerConnection.createOffer();

                // If the connection hasn't yet achieved the "stable" state,
                // return to the caller. Another negotiationneeded event
                // will be fired when the state stabilizes.
                if(this.myPeerConnection.signalingState != "stable") {
                    console.log("     -- The connection isn't stable yet; postponing...")
                    return;
                }

                // Establish the offer as the local peer's current
                // description.
                console.log("---> Setting local description to the offer");
                await this.myPeerConnection.setLocalDescription(offer);

                // Send the offer to the remote peer.
                console.log("---> Sending the offer to the remote peer");
                let webRtcObj = {
                    to_sid: this.targetUser.sid,
                    type: "video_offer",
                    sdp: this.myPeerConnection.localDescription
                }
                this.socketSend(webRtcObj);
                
            } catch(error) {
                console.log("*** The following error occurred while handling the negotiationneeded event: ", error);
            };
        },

        // Called by the WebRTC layer when events occur on the media tracks
        // on our WebRTC call. This includes when streams are added to and
        // removed from the call.
        //
        // track events include the following fields:
        //
        // RTCRtpReceiver       receiver
        // MediaStreamTrack     track
        // MediaStream[]        streams
        // RTCRtpTransceiver    transceiver
        //
        // In our case, we're just taking the first stream found and attaching
        // it to the <video> element for incoming media.
        handleTrackEvent: function(event) {
            console.log("*** Track event");
            document.getElementById("received_video").srcObject = event.streams[0];
            //document.getElementById("hangup-button").disabled = false;
        },


        handleIncomingVideoOffer: async function(sdp) {
            // If we're not already connected, create an RTCPeerConnection
            // to be linked to the caller.
            if(!this.myPeerConnection) {
                this.createPeerConnection();
            }

            // We need to set the remote description to the received SDP offer
            // so that our local WebRTC layer knows how to talk to the caller.
            let desc = new RTCSessionDescription(sdp);
            console.log('DESC OBJ: ', desc);

            // If the connection isn't stable yet, wait for it...
            if (this.myPeerConnection.signalingState != "stable") {
                console.log("  - But the signaling state isn't stable, so triggering rollback");
                // Set the local and remove descriptions for rollback; don't proceed
                // until both return.
                await Promise.all([
                    this.myPeerConnection.setLocalDescription({type: "rollback"}),
                    this.myPeerConnection.setRemoteDescription(desc)
                ]);
                return;
            } else {
                console.log ("  - Setting remote description");
                await this.myPeerConnection.setRemoteDescription(desc);
            }


            // Get the webcam stream if we don't already have it
            if (!this.webcamStream) {
                try {
                    this.webcamStream = await navigator.mediaDevices.getUserMedia(this.mediaConstraints);
                } catch(error) {
                    this.handleGetUserMediaError(error);
                    return;
                }
                document.getElementById("local_video").srcObject = this.webcamStream;
                // Add the camera stream to the RTCPeerConnection
                try {
                    let self = this;
                    this.webcamStream.getTracks().forEach(
                        self.rtcTransceiver = track => self.myPeerConnection.addTransceiver(track, {streams: [self.webcamStream]})
                    );
                } catch(error) {
                    this.handleGetUserMediaError(error);
                }
            }

            console.log("---> Creating and sending answer to caller");

            await this.myPeerConnection.setLocalDescription(await this.myPeerConnection.createAnswer());

            let webRtcObj = ({
                to_sid: this.targetUser.sid,
                type: "video_answer",
                sdp: this.myPeerConnection.localDescription
            })
            console.log('SENDING VIDEO ANSWER RESPONSE!!!!!')
            this.socketSend(webRtcObj);
        },


        // A new ICE candidate has been received from the other peer. Call
        // RTCPeerConnection.addIceCandidate() to send it along to the
        // local ICE framework.
        handleNewICECandidateMsg: async function(message) {
            let candidate = new RTCIceCandidate(message);
            console.log('ice candidate object: ', candidate)

            console.log("*** Adding received ICE candidate: " + JSON.stringify(candidate));
            try {
                await this.myPeerConnection.addIceCandidate(candidate)
            } catch(error) {
                this.handleGetUserMediaError(error);
            }
        },

        // Responds to the "video-answer" message sent to the caller
        // once the callee has decided to accept our request to talk.
        handleIncomingVideoAnswer: async function(sdp) {
            console.log("*** Call recipient has accepted our call");

            // Configure the remote description, which is the SDP payload
            // in our "video-answer" message.
            let desc = new RTCSessionDescription(sdp);
            console.log('VIDEO ANSWER: ', desc);
            await this.myPeerConnection.setRemoteDescription(desc).catch(error => {
                console.log('received video answer error: ', error);
            });
        },

















        handleGetUserMediaError: function(error) {
            console.log(error);
            switch(error.name) {
                case "NotFoundError":
                    alert("Unable to open your call because no camera and/or microphone were found.");
                    break;
                case "SecurityError":
                case "PermissionDeniedError":
                    // Do nothing; this is the same as the user canceling the call.
                    break;
                default:
                    alert("Error opening your camera and/or microphone: " + error.message);
                    break;
            }
        },


        closeVideoCallClick: function() {
            console.log('close video click. target user: ', this.targetUser);
            if(this.targetUser.sid) {
                // This means that the video call has already been established
                let webRtcObj = {
                    to_sid: this.targetUser.sid,
                    type: "video_hangup",
                }
                this.socketSend(webRtcObj);
            }
            else {
                // This means that the caller is cancelling the call before the user has answered
                this.$socket.emit('webrtc_cancel', {to_username: this.targetUser.user_username});
            }
            this.closeVideoCall();
        },





        shareScreenClick: async function() {
            console.log('myPeerConnection:', this.myPeerConnection);
            console.log('webcamStream:', this.webcamStream);
            console.log('rtcTransceiver:', this.rtcTransceiver);

            let rtcSenders = this.myPeerConnection.getSenders();
            console.log('myPeerConnection SENDERS: ', this.myPeerConnection.getSenders());

            let displayMediaStream = await navigator.mediaDevices.getDisplayMedia();
            console.log('displayMediaStream: ', displayMediaStream);
            console.log('displayMediaStreamTracks: ', displayMediaStream.getTracks());


            let localVideo = document.getElementById("local_video");
            localVideo.srcObject.getTracks().forEach(track => {
                if(track.kind == "video") {
                    console.log('localVideo.srcObject: ', localVideo.srcObject);
                    console.log('localVideo.srcObject Tracks: ', localVideo.srcObject.getTracks());
                    console.log('track before: ', track);

                    // Setup handler to go back to video sharing after the screen sharing is done. 
                    displayMediaStream.getTracks()[0].onended = function(e) {
                        console.log('SCREENSHARE ENDED!!! ', e);
                        rtcSenders.find(sender => sender.track.kind === 'video').replaceTrack(track);
                    };

                    // Replace the video track with the screenshare track
                    rtcSenders.find(sender => sender.track.kind === 'video').replaceTrack(displayMediaStream.getTracks()[0]);

                    console.log('track after: ', track);
                    localVideo.srcObject = displayMediaStream;
                }
            });
            //localVideo.srcObject = displayMediaStream;

        },

        toggleMicrophone: function() {
            let localVideo = document.getElementById("local_video");
            localVideo.srcObject.getTracks().forEach(track => {
                if(track.kind == "audio") {
                    track.enabled = !track.enabled;
                    this.microphoneOn = track.enabled;
                    this.$socket.emit('webrtc_microphone_status', {to_sid: this.targetUser.sid, status: this.microphoneOn});
                }
            });
        },

        toggleCamera: function() {
            let localVideo = document.getElementById("local_video");
            localVideo.srcObject.getTracks().forEach(track => {
                console.log('TRACK DEBUG!!!!: ', track);
                if(track.kind == "video") {
                    track.enabled = !track.enabled;
                    this.cameraOn = track.enabled;
                    // if(track.enabled) {
                    //     track.start();
                    // }
                    // else {
                    //     track.stop();
                    // }
                    this.$socket.emit('webrtc_camera_status', {to_sid: this.targetUser.sid, status: this.cameraOn});
                }
            });
        },

        minimizeWebRtc: function() {
            this.$store.commit('setMinimizeWebRtc', true);
        },


        setupControlsTimeout: function() {
            let self = this;

            this.showControlsIntervalFunc = setInterval(function() {
                self.showControlsTimerSeconds = (self.showControlsTimerSeconds - 1);
                if(self.showControlsTimerSeconds < 0) {
                    self.showControls = false;
                }
            }, 1000);

            // Show the controls tray when they move their mouse a little
            document.getElementById('video-chat-dialog').addEventListener('mousemove', e => {
                this.showControls = true;
                this.showControlsTimerSeconds = this.showControlsTimeoutSeconds;
            });
        },










        // Close the RTCPeerConnection and reset variables so that the user can
        // make or receive another call if they wish. This is called both
        // when the user hangs up, the other user hangs up, or if a connection
        // failure is detected.
        closeVideoCall: function() {
            console.log('CLOSE THE CALL!!');

            // Close the RTCPeerConnection
            if(this.myPeerConnection) {
                // Disconnect all our event listeners; we don't want stray events
                // to interfere with the hangup while it's ongoing.
                this.myPeerConnection.ontrack = null;
                this.myPeerConnection.onnicecandidate = null;
                this.myPeerConnection.oniceconnectionstatechange = null;
                this.myPeerConnection.onsignalingstatechange = null;
                this.myPeerConnection.onicegatheringstatechange = null;
                this.myPeerConnection.onnotificationneeded = null;

                // Stop all transceivers on the connection
                this.myPeerConnection.getTransceivers().forEach(transceiver => {
                    console.log(transceiver);
                    //transceiver.stop();
                });

                // Stop the webcam preview as well by pausing the <video>
                // element, then stopping each of the getUserMedia() tracks
                // on it.
                console.log('webcamStream: ', this.webcamStream);
                let localVideo = document.getElementById("local_video");
                if (localVideo.srcObject) {
                    localVideo.pause();
                    localVideo.srcObject.getTracks().forEach(track => {
                        console.log('local video track: ', track);
                        track.stop();
                    });
                }

                // Close the peer connection
                this.myPeerConnection.close();
                this.myPeerConnection = null;
                this.webcamStream = null;
            }

            let webRtc = {
                show: false, 
                contact: null,
                outgoing: false,
                incoming: false,
            };
            this.$store.commit('setWebRtc', webRtc);

            // Disable the hangup button
            //document.getElementById("hangup-button").disabled = true;
            //targetUsername = null;

        },

        socketSend: function(webRtcObj) {
            console.log('SENDING SOCK!', webRtcObj);
            this.$socket.emit('webrtcmessage', webRtcObj);
        },

        // Handle the "hang-up" message, which is sent if the other peer
        // has hung up the call or otherwise disconnected.
        handleHangUpMsg: function(message) {
            console.log("*** Received hang up notification from other peer");
            this.closeVideoCall();
        }

    },

    watch: {
    },

    sockets: {
        video_offer: function(message) {
            console.log('INCOMING VIDEO OFFER!: ', message);
            if(this.imTheCaller) {
                console.log('IM THE CALLER!');
                this.handleIncomingVideoOffer(message.sdp);
            }
            else {
                this.handleIncomingVideoOffer(message.sdp);
            }
        },

        new_ice_candidate: function(message) {
            console.log('ice_candidate: ', message);
            this.handleNewICECandidateMsg(message);
        },

        video_answer: function(message) {
            console.log('INCOMING VIDEO ANSWER: ', message);
            this.handleIncomingVideoAnswer(message.sdp);
        },

        video_hangup: function(message) {
            console.log('INCOMING HANG UP!: ', message);
            this.handleHangUpMsg(message);
        },

        webrtc_microphone_status: function(message) {
            console.log('THEY TURNED THERE MIC: ', message.status);
            this.contactMicrophoneOn = message.status;
            this.showContactMicrophoneStatus = true;
            let self = this;
            setTimeout(() => {
                self.showContactMicrophoneStatus = false;
            }, 1000);
        },

        webrtc_camera_status: function(message) {
            console.log('THEY TURNED THERE CAMERA: ', message.status);
            this.contactCameraOn = message.status;
        },

        WEBRTC_INVITE_REPLY: function(message) {
            console.log('WEBRTC_INVITE_REPLY: ', message);

            if(message.response == 'accept') {
                this.targetUser.sid = message.from_sid;
                this.acceptedInvite = true;
                this.prepareVideoChatInvite();
            }
            else if (message.response == 'reject') {
                // Close it down
                let webRtc = {
                    show: false, 
                    contact: null,
                    outgoing: false,
                    incoming: false,
                };
                this.$store.commit('setWebRtc', webRtc);
            }
        },

        WEBRTC_CANCEL: function(message) {
            this.closeVideoCall();
        }
    },

    mounted() {
        console.log('WEB RTC MOUNTED!!');
        if(this.$store.state.webRtc.outgoing) {
            this.targetUser = this.$store.state.webRtc.contact;
            // Doing this because the sid is the array from the contact. We will set sid later to 1 value. 
            delete this.targetUser.sid;
        }
        else if(this.$store.state.webRtc.incoming) {
            this.targetUser = this.$store.state.webRtc.contact;
        }


        this.setupControlsTimeout();

        
        

        // let sound = new Audio(require('@/assets/hangouts_outgoing.mp3'));
        // console.log(sound);
        // sound.play();
    },


    destroyed() {
        clearInterval(this.showControlsIntervalFunc);
    },

  
};
</script>






<style scoped>

    #video-chat-dialog {
        position: absolute;
        /* background-color: #000000; */
        background-color: #232526;
        width: 100%;
        height: 100%;
        z-index: 10;
    }
    #video-chat-dialog.minimize {
        display: none;
    }

    #minimize-web-rtc {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 13;
    }

    #contact-microphone-status-container {
        width: 100%;
        text-align: center;
        position: fixed;
        /* top: 50px; */
        z-index: 12;

        top: -200px;
        transition: all 0.3s;
    }
    #contact-microphone-status-container.show {
        top: 50px;
        transition: all 0.3s;
    }
    #contact-microphone-status {
        width: fit-content;
        position: relative;
        margin: auto;
        text-align: center;
        background-color: #232526;
        border: #000000 solid 2px;
        border-radius: 15px;
    }
    #contact-microphone-status .on {
        display: block;
        margin: 5px 10px;
        color: #00ff00;
    }
    #contact-microphone-status .off {
        display: block;
        margin: 5px 10px;
        color: #ff0000;
    }



    #contact-camera-off-container {
        position: absolute;
        top: calc(50% - (200px / 2));
        left: calc(50% - (200px / 2));
        animation: pulsate-bck 0.5s ease-in-out infinite both;
    }
    #contact-camera-off-container .user-image {
        max-width: 200px;
        max-height: 200px;
        border-radius: 50%;
        border: #ffffff 1px solid;
    }




    #received_video {
        width: 100%;
        height: 100%;
        padding: 10px;
        position: absolute;
        z-index: 11;
        border: #000000 solid 1px;
    }
    #received_video.hide {
        display: none;
    }

    #local_video {
        min-width: 100px;
        min-height: 100px;
        max-height: 25%;
        max-width: 25%;
        position: absolute;
        bottom: 10px;
        right: 10px;
        z-index: 10;
        border: #000000 solid 1px;
    }


    





    #in-call-buttons-container {
        position: fixed;
        width: 320px;
        height: 75px;
        margin-left: calc(50% - (320px / 2));
        text-align: center;
        z-index: 12;
        background-color: #232526;
        border: #000000 solid 2px;
        border-radius: 20px;
        padding: 10px;

        bottom: -200px;
        transition: all 0.3s;
    }
    #in-call-buttons-container.show {
        bottom: 1em;
    }





    .control-button {
        position: relative;
        z-index: 13;
        cursor: pointer;
        display: inline-block;
        margin-left: 8px;
        margin-right: 8px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        cursor: pointer;

        background-color: rgba(255, 255, 255, 0.2);
        border: #ffffff solid 2px;
    }
    .control-button:hover {
        background-color: rgba(255, 255, 255, 0.4);
    }

    #toggle-microphone {
        /* border: #ffffff solid 2px; */
        padding-top: 11px;
    }
    #toggle-microphone i {
        color: #ffffff;
    }
    #toggle-microphone.inactive {
        background-color: #ff0000;
        border: #ff0000 solid 2px;
    }
    #toggle-microphone.inactive i {
        color: #ffffff;
    }

    #end-call-button {
        background-color: #ff0000;
        border: #ff0000 solid 2px;
        padding-top: 11px;
    }
    #end-call-button i {
        color: #ffffff;
    }

    #toggle-camera {
        /* background-color: rgba(255, 255, 255, 0.2); */
        /* border: #ffffff solid 2px; */
        padding-top: 11px;
    }
    #toggle-camera i {
        color: #ffffff;
    }
    #toggle-camera.inactive {
        background-color: #ff0000;
        border: #ff0000 solid 2px;
    }
    #toggle-camera.inactive i {
        color: #ffffff;
    }

    #share-screen-button {
        /* background-color: rgba(0,0,0,0.6); */
        /* background-color: rgba(255, 255, 255, 0.2); */
        /* border: #ffffff solid 2px; */
        padding-top: 11px;
    }
    #share-screen-button i {
        color: #ffffff;
    }
    




    .incoming-call-container {
        position: absolute;
        text-align: center;
        margin: auto;
        width: 100%;
        top: calc(50% - ((200px + 10em) / 2));
    }
    .incoming-call-container span {
        font-size: 18pt;
        display: block;
        margin-bottom: 1em;
    }
    .incoming-call-container img {
        max-width: 200px;
        max-height: 200px;
        border-radius: 50%;
    }
    .incoming-call-container .button-container {
        margin-top: 2em;
        animation: pulsate-bck 0.5s ease-in-out infinite both;
    }




    .stock-image {
        width: 200px;
        height: 200px;
        border-radius: 50%;
        background-color: rgba(0, 100, 0, 0.5);
        border: #ffffff 1px solid;
        text-align: center;
        position: relative;
        margin-left: calc(50% - (200px / 2));
    }
    .stock-image .letter {
        color: #ffffff;
        font-size: 90px;
        font-weight: bold;
        display: block;
        position: relative;
        margin-top: 30px;
        -webkit-text-stroke: 1px black;
    }




    .outgoing-call-container {
        position: absolute;
        text-align: center;
        margin: auto;
        width: 100%;
        top: calc(50% - ((200px + 10em) / 2));
    }
    .outgoing-call-container span {
        font-size: 18pt;
        display: block;
        margin-bottom: 1em;
    }
    .outgoing-call-container img {
        max-width: 200px;
        max-height: 200px;
        border-radius: 50%;
    }








    .dots {
        margin-top: 1em;
        text-align: center;
    }
    .dot {
        height: 10px;
        width: 10px;
        display: inline-block;
        border-radius: 50%;
        background-color: rgba(0, 128, 0, 0.4);
        animation: showHideDot 1.2s  infinite;
    }
    .dot.one {
        animation-delay: 0s;
    }
    .dot.two {
        animation-delay: 0.2s;
    }
    .dot.three {
        animation-delay: 0.4s;
    }
    .dot.four {
        animation-delay: 0.6s;
    }
    .dot.five {
        animation-delay: 0.8s;
    }
    @keyframes showHideDot {
        /* 0% { background-color: rgba(0, 128, 0, 0.4); } */
        0% { background-color: green; }
        /* 60% { background-color: green; }
        100% { background-color: darkgreen; } */
    }

    @keyframes pulsate-bck {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(0.9);
        }
        100% {
            transform: scale(1);
        }
    }
    

</style>
